<template>
  <div style="height: 100%; display: flex; flex-direction: column;justify-content: space-between;">
    <div class="w-100  d-flex" style="justify-content: space-between;align-items: center;">

      <div class="d-flex" style="align-items: center;">
        <div class="pr-3" @click="$emit('cancel')" style="display: grid;place-items: center;">
          <i class="now-ui-icons ui-1_simple-remove" style="font-weight: 900;font-size: 1.2em;color: #a5a5a5;"></i>
        </div>

        <div>
          <h5 class="m-0" style="font-size: 1.4em;font-weight: bold;" v-if="!replyTo">
            <span>{{ updatePost ? $t('message.Update a post') : $t('message.Create a post') }}</span>
          </h5>

          <div v-else>
            <div class="col-12 ">
              <div style="font-weight: 600; color: grey">{{ $t('message.Replying to') }}</div>

              <div>
                <div style="display: flex;gap: 1em;align-items: center;">
                  <div>
                    <profile-image v-if="replyTo.author.profileImage" :file-id="replyTo.author.profileImage" :image-style="profileImageStyle">
                    </profile-image>
                    <img v-else :src="defaultImage" alt="" srcset="" :style="profileImageStyle">
                  </div>
                  <div style="line-height: 1em;">
                    <div>
                      <span>
                        <strong>
                          {{ replyTo.author.firstName }} {{ replyTo.author.lastName }}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <n-button v-if="type == 'Post'" type="primary" round @click.native="postInForum" :disabled="!(title.trim() && description.trim())" class="m-0">
          <i class="fas fa-paper-plane pr-1"></i>
          {{ updatePost ? $t('message.Update') : $t('message.Post') }}
        </n-button>

        <n-button v-if="type == 'Reply'" type="primary" round @click.native="postInForum" :disabled="description.trim() ? false : true">
          <i class="fas pr-1" :class="replyTo ? 'fa-reply' : 'fa-paper-plane'"></i>
          <span v-if="!replyTo">{{ updatePost ? $t('message.Update') : $t('message.Post') }}</span>
          <span v-else>{{ $t('message.Reply') }}</span>
        </n-button>
      </div>
    </div>

    <div style="font-size: 1.25em;overflow-y: auto;overflow-x: hidden;" class="mt-4">
      <textarea v-if="type == 'Post'" :placeholder="$t('message.Type your question/queries here')" class="form-control mb-3" style="font-weight: 600;max-height: unset;" @input="titleInputChange"></textarea>

      <textarea v-show="type == 'Post'" :placeholder="$t('message.Elaborate your question/queries here')" class="form-control" rows="5" style="max-height: unset" @input="inputChange"></textarea>

      <textarea :placeholder="$t('message.Write your comment here')" v-if="type == 'Reply'" class="form-control" rows="5" style="max-height: unset" @input="inputChange"></textarea>

      <div style="width: 100%;height: 20rem;" class="mt-3">

        <!-- Media placeholder -->
        <div class="row" style="padding-top: 5rem" v-if="!attachments.length">
          <div class="col-12 text-center">
            <i class="fas fa-photo-video fa-4x" style="color: var(--light);"></i>
          </div>
        </div>
        <div style="justify-content: center;display: flex;text-align: center;">
          <carousel style="width: 90%" :per-page="1" v-if="attachments && attachments.length > 0" :navigationEnabled="!isTouchScreenDevice">
            <slide v-for="(attachment, index) in attachments" :key="attachment.id || attachment.fileId">
              <div v-if="attachment.mediaType" style="border-radius: 1em; overflow:hidden;height: 100%;position: relative;background: var(--dark);display: grid;place-items: center;height: 40vh;">
                <dynamic-image v-if="attachment.mediaType.indexOf('image') > -1" :file-url="attachment.dataURI">
                </dynamic-image>
                <dynamic-video v-if="attachment.mediaType.includes('video/')" :file-url="attachment.dataURI" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{ controls: true }" />
                <div class="btn-cancel-attachment" @click="removeAttachment(index)">
                  <!-- <i class="now-ui-icons ui-1_simple-remove"></i> -->
                  <i class="fas fa-times"></i>
                </div>
              </div>

              <div v-if="!attachment.mediaType" style="border-radius: 1em; overflow:hidden;height: 100%;position: relative;background: var(--dark);display: grid;place-items: center;">
                <dynamic-image v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId">
                </dynamic-image>
                <dynamic-video v-if="attachment.type.includes('video/')" :file-id="attachment.fileId" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{ controls: true }" />
                <div class="btn-cancel-attachment" @click="removeAttachment(index)">
                  <!-- <i class="now-ui-icons ui-1_simple-remove"></i> -->
                  <i class="fas fa-times"></i>
                </div>
              </div>
            </slide>
          </carousel>
        </div>

      </div>
    </div>

    <!--Upload Image -->
    <div>
      <div class="text-center" style="display: flex;justify-content: space-evenly;">
        <n-button :disabled="attachments.length >= 4" style="margin-right:1em;" type="primary" round @click.native="openFileChooser('image/*,video/*')" simple class="mb-0">
          <i class="fas fa-image"></i>
          {{ $t("message.Select") }}
        </n-button>
        <n-button :disabled="attachments.length >= 4" type="primary" round @click.native="openCameraForFileUpload" simple class="mb-0">
          <i class="fa fa-camera"></i>
          {{ $t("message.Capture") }}
        </n-button>
        <input type="file" ref="fileInput" accept="image/*,video/*" style="display: none" @change="onFileSelect">
      </div>
      <div class="text-center mt-1">
        <div style="font-size: 0.8em;color: red;font-style: italic;">*{{ $t("message.Maximum file size allowed is 10MB!") }}</div>
      </div>
    </div>

    <!-- camera component -->
    <app-camera :showCam="SHOW_CAPTURE_MODAL" ref="camera" @closeCamera="closeCaptureModal" @imageCaptured="saveImage">
    </app-camera>

  </div>
</template>

<script>
import Modal from '../../../../components/Modal.vue';
import AppCamera from '../AppCamera.vue';
export default {
  components: { Modal, AppCamera },
  props: ["type", "replyTo", "updatePost"],

  data() {
    return {
      defaultImage: require("@/assets/img/proAvatar.png"),
      profileImageStyle:
        "width: 2.5rem;height: 2.5rem; border-radius: 50%; margin: auto;",
      title: "",
      description: "",
      image: "",
      attachments: [],
      selectedFile: null,
      SHOW_CAPTURE_MODAL: false
    };
  },

  mounted() {
    if (this.updatePost && this.updatePost._id) {
      if (this.updatePost.title) {
        this.title = this.updatePost.title;
      }
      if (this.updatePost.description) {
        this.description = this.updatePost.description;
      }
      if (this.updatePost.attachments) {
        this.attachments = this.updatePost.attachments;
      }
    }
  },

  methods: {
    inputChange(event) {
      this.description = event.target.value || ''
    },
    titleInputChange(event) {
      this.title = event.target.value || ''
    },
    async postInForum() {
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      try {
        let newForumPost = {
          title: this.title,
          description: this.description,
          type: this.type,
          attachments: this.attachments,
        };

        if (this.type == "Reply") {
          newForumPost.replyTo = this.replyTo._id;
        }

        if (this.updatePost && this.updatePost._id) {
          newForumPost.postId = this.updatePost._id;
          await this.$store.dispatch("updatePost", newForumPost);
        } else {
          await this.$store.dispatch("postInForum", newForumPost);
        }

        loader.hide();
        swal.fire({
          title: this.$t("message.Success!"),
          text: this.$t("message.Posted successfully!"),
          type: "success",
          timer: 3000,
          showCloseButton: true,
        });
        this.$emit("forumPostCreated");
      } catch (error) {
        console.log(error);
        loader.hide();
        swal.fire({
          title: this.$t("message.bookings4") + "!",
          text: this.$t("message.Error while posting!"),
          type: "error",
          timer: 3000,
          showCloseButton: true,
        });
      }
    },

    // file upload functionality
    async openFileChooser(fileType) {
      if (window.cordova) {
        let _this = this;
        let loader = _this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        let file = await chooser.getFile(fileType);
        console.log("AScasc", file)
        if (file) {
          loader.hide();
          delete file.data;
          file.id = new Date().getTime();
          this.attachments.push(file);
        }
        loader.hide();

      } else {
        this.$refs.fileInput.click()
      }

    },

    onFileSelect(event) {
      let that = this
      let file = event.target.files[0]
      const reader = new FileReader();

      reader.onload = function (e) {
        // e.target.result contains the Data URI
        const dataURI = e.target.result;
        // Now you can use the dataURI as needed
        let fileToUpload = {
          dataURI: dataURI,
          id: new Date().getTime(),
          mediaType: file.type,
          name: file.name
        }
        that.attachments.push(fileToUpload);
      };
      reader.readAsDataURL(file)
    },

    async openCameraForFileUpload() {
      if (window.cordova) {
        var _this = this;
        navigator.camera.getPicture(
          async function (base64Data) {
            var fileData = "data:image/png;base64," + base64Data;

            _this.attachments.push({
              dataURI: fileData,
              name: "camera.png",
              mediaType: "image/png",
              id: new Date().getTime(),
            });
          },
          function (err) {
            console.log("error opening camera");
          },
          {
            sourceType: Camera.PictureSourceType.CAMERA,
            destinationType: Camera.DestinationType.DATA_URL,
            mediaType: Camera.MediaType.PICTURE,
            // allowEdit: true,
            correctOrientation: false,
            encodingType: Camera.EncodingType.PNG,
            quality: 10,
            cameraDirection: Camera.Direction.BACK,
            targetWidth: 300,
            targetHeight: 400,
          }
        );
      }
      else {
        this.SHOW_CAPTURE_MODAL = true
        setTimeout(() => {
          this.$refs.camera.createCameraElement();
        }, 1000);
      }

    },

    closeCaptureModal() {
      this.SHOW_CAPTURE_MODAL = false;
    },

    async saveImage(fileData) {
      let _this = this;

      const { value: fileName } = await swal.fire({
        title: _this.$t("message.Enter file name"),
        input: "text",
        inputValue: "Untitled.png",
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && "Please Enter filename!";
        },
      });

      if (fileName) {
        let fileToSave = {
          dataURI: fileData,
          id: new Date().getTime(),
          name: fileName.endsWith(".png") ? fileName : fileName + ".png",
          mediaType: "image/png",
        };
        _this.attachments.push(fileToSave);
      }
    },


    async removeAttachment(index) {
      this.attachments.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.btn-cancel-attachment {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  background: #ebebeb;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  display: grid;
  place-items: center;
}

textarea:focus {
  border: 1px solid var(--color-primary);
}

textarea {
  border: 1px solid #e3e3e3;
  border-radius: 1rem;
  padding: 1rem;
}

/deep/ .VueCarousel-inner,
/deep/ .VueCarousel,
/deep/ .VueCarousel-wrapper {
  height: 100% !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}
</style>
